import Form from "react-bootstrap/Form";

export default function InputWithSelect({
  inputId,
  label = null,
  placeholder = "",
  options = [],
  // Pass over the react-hook-form register function!
  register,
  error = null,
  errorMessage = "Required field.",
  validation = {},
  disabled = false,
  // Wraper styling, default to margin bottom 3 (mb-3)
  wrapperClass = "mb-3",
  inputProps = null,
}) {
  if (!inputId) {
    console.error(`ERR: Missing input ID! InputWithLabel`);
    return <></>;
  }

  if (!Array.isArray(options) || options.length === 0) {
    console.error(`ERR: Missing options array! InputWithSelect`);
  }

  return (
    <div className={wrapperClass}>
      <label htmlFor={inputId} className="form-label">{label} {validation?.required ? <span className="text-danger">*</span> : null}</label>
      <Form.Select {...register(inputId, { ...validation })} className="form-control" {...inputProps} disabled={disabled}>
        <option className='text-muted' value="-1">
          Select
        </option>
        {options.map((item) => {
          return (
            <option {...item.props} value={item.value} key={item.value}>
              {item.label}
            </option>
          );
        })}
      </Form.Select>
      {error ? <label className="error">{errorMessage}</label> : null}
    </div>
  );
}
